import {FC, KeyboardEvent} from 'react'
import { KTSVG } from '../../../../../_metronic/helpers'
import { TagParams } from './TagsList'

export type TagFilterProps = {
  params: TagParams
  setParams: (p: TagParams) => void
  doFetch: () => void
}

const TagFilter: FC<TagFilterProps> = ({params, setParams, doFetch}) => {
  const handleSearchEnter = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      doFetch()
    }
  }

  return (
    <div className='d-flex mt-5 align-items-start position-relative flex-column flex-sm-row'>
      <div className='relative'>
        <KTSVG
          path='/media/icons/duotune/general/gen021.svg'
          className='svg-icon-1 position-absolute ms-6 mt-3'
        />
        <input
          type='text'
          value={params.search ? params.search : ''}
          data-kt-user-table-filter='search'
          className='form-control form-control-solid w-250px ps-14'
          placeholder='input and press enter'
          onChange={(e: any) => setParams({...params, search: e.target.value, page: 1})}
          onKeyDown={handleSearchEnter}
        />
      </div>
    </div>
  )
}

export default TagFilter
